export const SYNCFUSION_LICENSE =
  "Ngo9BigBOggjGyl/Vkd+XU9FcVRDX3xKf0x/TGpQb19xflBPallYVBYiSV9jS3tSd0dmWXZec3BcRGNcV091Xg==";
